import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    reload: "",
    speaker: [],
    messages: [],
    quoteTarget: null
  },
  getters: {},
  actions: {
    PushMessage: function(context, messages) {
      context.commit("push_Message", messages);
    },
    CheckSpeaker: function(context, speaker) {
      context.commit("check_Speaker", speaker);
    },
    SetQuoteTarget: function(context, quoteTarget) {
      context.commit("set_QuoteTarget", quoteTarget);
    }
  },
  mutations: {
    check_Speaker: function(state, payload) {
      state.reload = new Date();
      state.speaker = payload;
    },
    push_Message: function(state, payload) {
       state.messages = payload;
    },
    set_QuoteTarget: function(state, payload) {
      state.quoteTarget = payload;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_chat.js